import { render, staticRenderFns } from "./EditSpanco.vue?vue&type=template&id=2d258902"
import script from "./EditSpanco.vue?vue&type=script&lang=js"
export * from "./EditSpanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports